import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';
import { motify } from 'moti';

export const MotiView = withStyles(motify(CoreView)(), {noSwitch: true});